import { $, $$, isMobile } from '@utils';

function init() {
  if (!$('[data-au-dropdown]')) return;

  isMobile.addEventListener('change', () => {
    addEventListeners();
  });

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-dropdown-option-btn]').forEach((el) => {
    el.addEventListener('click', dropdownSelection);
  });
}

function dropdownSelection(e) {
  const trigger = e.target,
    selectedCategory = trigger.querySelector('span:not([data-au-icon])').innerText,
    collapsable = trigger.closest('[data-au-collapsable-parent]').querySelector('[data-au-collapsable]'),
    collapsableContent = trigger.closest('[data-au-collapsable-content]'),
    collapsableIcon = collapsable.querySelector('[data-au-collapsable-icon]'),
    collapsableCategories = collapsableContent.querySelectorAll('[data-au-dropdown-option-btn]'),
    collapsableCategoryText = collapsable.querySelector('[data-au-collapsable-subtitle-text]');

  // Remove active class on selected option.
  // Set tabindex="-1" on selected option to avoid focus on it when not visible.
  // Close dropdown and change icon and aria-expanded attribute when select a category.
  // Change text of selected category.
  collapsableCategories.forEach((options) => {
    options.classList.remove('au-active');
    options.setAttribute('tabindex', '-1');
  });
  trigger.classList.add('au-active');
  collapsableContent.classList.add('au-closed');
  collapsable.classList.add('au-closed');
  collapsable.setAttribute('aria-expanded', 'false');
  collapsableIcon.textContent = 'unfold_more';

  collapsableCategoryText.textContent = selectedCategory;
}

export default { init };
